<template>
    <!-- Bread crumb -->
    <div class="row page-titles">
        <div class="col-12 col-md-8 align-self-center">
            <h3 class="text-primary">{{ route }}</h3> </div>
            <div class="d-xs-none col-md-4 align-self-center">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
                    <li class="breadcrumb-separator" aria-hidden="true"><i class="fa-light fa-chevron-right"></i></li>
                    <li class="breadcrumb-item active">{{ route }}</li>
                </ol>
            </div>
        </div>
</template>

<script>
	export default {

		props: {
			route: {
				type: String,
				required: true,
			},
		},
	}
</script>
<style scoped>
	h3 {
		white-space: nowrap;
		background-color: #ffffff;
	}
    .row.page-titles {
        z-index: 100;
		margin-top: 54px;
    }
	.availabilitycalendar .row.page-titles, .constraints .row.page-titles {
		z-index: 1;
	}
	.breadcrumb-separator {
		display: flex;
		align-items: center;
		padding: 0 6px;
		color: #a6b7bf;
		font-size: 10px;
	}
</style>